import partnerRouteList from '../../../routes/PageRouteList/partnerRouteList';
import authUtil from '../../../util/auth';

/**
 * Returns the first path to a partner page that the user can view.
 * @param loggedInUserPartner
 * @returns string page path
 */
export const getDefaultPartnerLandingPath = (loggedInUserPartner) => {
   const firstPartnerRouteMatch = partnerRouteList?.find((routeItem) => {
      return authUtil.hasAuthAccessBase({
         access: routeItem?.access,
         userRoleListPartner: loggedInUserPartner?.roles,
      });
   });

   return firstPartnerRouteMatch?.path;
};

export default {
   getDefaultPartnerLandingPath,
};
